<template>
    <div class="privacy-alert-main">
      <transition name="alert">
        <div class="box" v-if="alertData.show && alertData.type === 'privacy'">
          <div class="message-header">
            简历权限设置
          </div>
          <div class="content">
            <div :class="['list', value === 'in_private' ? 'active' : '']" @click="value = 'in_private'">
              <div class="list-title">
                <div class="select"><i class="iconfont iconcheck"></i></div>
                <div>私密</div>
              </div>
              <div class="msg">仅自己可以查看</div>
            </div>
            <div :class="['list', value === 'hr_visible' ? 'active' : '']" @click="value = 'hr_visible'">
              <div class="list-title">
                <div class="select"><i class="iconfont iconcheck"></i></div>
                <div>HR 可见</div>
              </div>
              <div class="msg">让 HR 看见你</div>
            </div>
            <!-- <div :class="['list', value === 'in_public' ? 'active' : '']" @click="value = 'in_public'">
              <div class="list-title">
                <div class="select"><i class="iconfont iconcheck"></i></div>
                <div>公开</div>
              </div>
              <div class="msg">所有人都可以查看</div>
            </div> -->
          </div>
          <div class="message-btn">
            <button :class="['cancel', alertData.cancelButtonClass ||'' ]" @click="cancel" v-if="alertData.showCancelButton">{{alertData.cancelButtonText || '取消'}}</button>
            <button :class="['action', alertData.confirmButtonClass ||'' ]" v-if="alertData.showConfirmButton" @click="confirm">{{alertData.confirmButtonText || '确定'}}</button>
          </div>
        </div>
      </transition>
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
  name: 'message',
  data() {
    return {
      value: 'in_public'
    };
  },
  computed: {
    ...mapState('app', ['alertData'])
  },
  watch: {
    'alertData': {
      keep: true,
      immediate: true,
      handler: function (alertData) {
        if (!alertData.show) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }else{
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
        if (alertData.inputData) {
          this.value = alertData.visibility || '';
        }
      }
    }
  },
  methods: {
    close() {
      this.$store.dispatch('app/setAlertDataShow', false);
    },
    cancel() {
      this.alertData.cancel && this.alertData.cancel(this.close);
      // this.close();
    },
    confirm() {
      this.alertData.confirm && this.alertData.confirm(this.close, this.value);
    },
    inputChange(value) {
      if (!this.alertData.inputData || !this.alertData.inputData.length)
        return false;
      this.value = String(this.value).substr(0, +this.alertData.inputData.length);
    }
  }
}
</script>
<style lang="scss" scoped>
  .privacy-alert-main {
    width: 0;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      left: 0;
    }
    .box {
      width: 446px;
      height: 223px;
      background: #fff;
      border-radius: 4px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      .message-header {
        height: fit-content;
        // border-bottom: 1px solid #E8E8E8;
        font-size: 18px;
        font-weight: 600;
        color: #404040;
        // line-height: 72px;
        padding: 32px 32px 18px 32px;
      }
      .content {
        padding: 0 32px;
        margin-top: 20px;
        .list {
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
          }
          &.active .select {
            border-color: #FF4F4C!important;
            color: #FF4F4C!important;
            .iconfont {
              display: inline;
            }
          }
          .list-title {
            width: 105px;
            display: flex;
            align-items: center;
            color: #404040;
            .select {
              width: 16px;
              height: 16px;
              border: 1px solid #D9D9D9;
              margin-right: 12px;
              i {
                display: none;
              }
            }
          }
          .msg {
            font-size: 12px;
            color: #909090;
          }
        }
      }
      .message-btn {
        text-align: right;
        // position: absolute;
        // bottom: 25px;
        // right: 28px;
        padding: 25px 32px 26px 32px;
        display: flex;
        justify-content: flex-end;
        button {
          display: block;
          width: 80px;
          height: 36px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
          font-size: 14px;
          color: #606060;
          background: #fff;
          &.action {
            background: #FF4F4C;
            border-color: #FF4F4C;
            color: #fff;
          }
          &.cancel.seccess{
            border-color: #FF4F4C;
            color: #FF4F4C;
          }
          &:last-child {
            margin-left: 16px;
          }
        }
      }
    }
  }
</style>
